import { isDefined } from "@clipboard-health/util-ts";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { SHIFT_DISCOVERY_WORKPLACE_PROFILE_FULL_PATH } from "@src/appV2/redesign/ShiftDiscovery/paths";
import { generatePath, useHistory, useLocation } from "react-router-dom";

import { ChatHeader } from "../../Chat/ChatHeader";

interface FlexChatHeaderProps {
  workplaceName?: string;
  channelShiftTime?: string;
  workplaceId: string;
  fallbackGoBackPath: string;
  isWorkplaceGroupChannel?: boolean;
}

function getTitleVariant(title: string | undefined): "h6" | "body1" | "body2" | "caption" {
  if (!isDefined(title)) {
    return "h6";
  }

  const { length } = title;

  if (length < 30) {
    return "h6";
  }

  if (length < 40) {
    return "body1";
  }

  if (length < 50) {
    return "body2";
  }

  return "caption";
}

export function FlexChatHeader(props: FlexChatHeaderProps) {
  const {
    workplaceName,
    channelShiftTime,
    workplaceId,
    fallbackGoBackPath,
    isWorkplaceGroupChannel = false,
  } = props;
  const history = useHistory();
  const location = useLocation();

  function handleViewFacilityProfile() {
    logEvent(APP_V2_USER_EVENTS.VIEWED_FACILITY_PROFILE, {
      workplaceId,
      trigger: "Chat Header",
    });
    history.push(generatePath(SHIFT_DISCOVERY_WORKPLACE_PROFILE_FULL_PATH, { workplaceId }));
  }

  function handleGoBack() {
    if (isDefined(location.key)) {
      history.goBack();
    } else {
      history.push(fallbackGoBackPath);
    }
  }

  function getTitle() {
    if (!isDefined(workplaceName)) {
      return "";
    }

    if (isWorkplaceGroupChannel) {
      return `Group: ${workplaceName}`;
    }

    return workplaceName;
  }

  const title = getTitle();

  return (
    <ChatHeader
      title={title}
      subtitle={isWorkplaceGroupChannel ? "Professionals Only" : channelShiftTime}
      titleVariant={getTitleVariant(title)}
      onBack={() => {
        handleGoBack();
      }}
      onTitleClick={() => {
        handleViewFacilityProfile();
      }}
    />
  );
}
